import { render, staticRenderFns } from "./WithdrawFail.vue?vue&type=template&id=e93ca3e6"
import script from "./WithdrawFail.vue?vue&type=script&lang=js"
export * from "./WithdrawFail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports